/*
   '-keep' twin routes run the partner-mode (AOE-free) variant of a page while the
   original route stays frozen on the legacy AOE-backed behavior, so the team can
   validate both side by side before the DE/AOE shutdown (de-shutdown-decisions §2
   KEEP+FIX). Shared components and services branch on this helper instead of being
   copy-pasted — one component, two routes, zero drift.
*/

export const KEEP_SUFFIX = '-keep';

export const isKeepTwinPath = (pathname) => {
   const p = pathname !== undefined ? pathname : window.location.pathname;
   return typeof p === 'string' && p.includes(KEEP_SUFFIX);
};
